var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.231,
    height: 55.385,
    viewBox: "0 0 49.231 55.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cab56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edd47a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_line_weight_24px",
    d: "M0,40H55.385V33.846H0Zm0,9.231H55.385V46.154H0ZM0,27.693H55.385V18.462H0ZM0,0V12.308H55.385V0Z",
    transform: "translate(0 55.385) rotate(-90)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdBarcode);
export default __webpack_public_path__ + "static/media/mdBarcode.c922984a5dd2d746a0f966d89f9c337a.svg";
export { ForwardRef as ReactComponent };